import { Box, Flex, Text } from '@fullstory/components';
import React from 'react';
import { MLPill } from '@fullstory/library-ui';
import css from './managed.module.scss';
import { FormattedMessage } from 'react-intl';

export const FullstoryManaged = () => (
  <Box padding={[8, 24, 8, 24]} className={css.container}>
    <Flex justifyContent="flex-start" alignItems="center">
      <Box marginRight={8}>
        <MLPill />
      </Box>
      <Text appearance="bodyMedium">
        <FormattedMessage
          defaultMessage="These rules are learned and managed by Fullstory."
          id="i4aWOJ"
        />
      </Text>
    </Flex>
  </Box>
);
